import { isBefore } from 'date-fns';

import { HousekeepingInspection } from '../api/types';
import { InspectionState } from '../components/enum/inspection-state';

export const getInspectionStates = (inspection: HousekeepingInspection): InspectionState => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { opted_in, opted_out, opt_in_deadline, cancelled, assigned_time } = inspection;

    const now = new Date();

    const isBeforeOptInDeadline =
        opt_in_deadline === null ? true : isBefore(now, new Date(opt_in_deadline));

    switch (true) {
        case !opted_in && !opted_out && !cancelled && isBeforeOptInDeadline:
            return InspectionState.UPCOMING;
        case opted_in && !assigned_time:
            return InspectionState.REQUESTED;
        case opted_out:
        case !opted_in && !opted_out && !cancelled && !isBeforeOptInDeadline:
            return InspectionState.SKIPPED;
        case cancelled:
            return InspectionState.CANCELLED;
        case opted_in && Boolean(assigned_time):
            return InspectionState.CONFIRMED;
        default:
            return InspectionState.UPCOMING;
    }
};
